import { VerNotificacoesFornecedorActionsTypes } from "./verNotificacoesFornecedorActions"
import type { VerNotificacoesFornecedorActions } from "./verNotificacoesFornecedorActions"
import type { VerNotificacoesFornecedorModel } from "../models/verNotificacoesFornecedorModel"

const { CARREGAR_ENVIADAS, CARREGAR_AGENDADAS, REMOVER_AGENDADA, SET_FILTRO } =
    VerNotificacoesFornecedorActionsTypes

export function verNotificacoesFornecedorReducer(
    state: VerNotificacoesFornecedorModel,
    action: VerNotificacoesFornecedorActions
): VerNotificacoesFornecedorModel {
    switch (action.type) {
        case CARREGAR_ENVIADAS:
            return { ...state, listaEnviadas: action.payload }

        case CARREGAR_AGENDADAS:
            return { ...state, listaAgendadas: action.payload }

        case REMOVER_AGENDADA:
            return {
                ...state,
                listaAgendadas: state.listaAgendadas.filter(n => n.id !== action.payload.id),
            }

        case SET_FILTRO:
            return { ...state, filtro: { ...state.filtro, ...action.payload } }

        default:
            return state
    }
}
